// extracted by mini-css-extract-plugin
export default {"title":"WorkflowActionPanel_title__As1Yd","icon":"WorkflowActionPanel_icon__iGqEf","heading":"WorkflowActionPanel_heading__PvF-4"};